import { useCurrentUser } from '@/api/Me';

export const useIsLoggedIn = (): boolean => useCurrentUser().data !== undefined;
